import { Warning } from "@phosphor-icons/react"

import { Badge } from "~/components/design-system/components"
import { Tooltip } from "~/components/reusable/Tooltip"
import { pluralize } from "~/utils/formatting"
import { overlapTooltip, packageIssueCount } from "./packageDisplay"
import type { RangePackage } from "./types"

/** Amber count of a package's open issues, for every place packages are listed. */
export function PackageIssueBadge({ pkg }: { pkg: RangePackage }) {
  const count = packageIssueCount(pkg)
  if (count === 0 || !pkg.overlap) return null
  return (
    <Tooltip title={overlapTooltip(pkg.overlap)}>
      <Badge variant="yellow" size="sm" aria-label={pluralize(count, "open issue")}>
        <Warning size={12} weight="fill" aria-hidden />
        {count}
      </Badge>
    </Tooltip>
  )
}
